import { createContainer, queryStringValue } from './utility';

let config, appContainer;
let vueInitalized = false;
/** The outer modal container */
const container = document.createElement('div');

/**
 * Show the modal container and initialize audio.
 */
export function show() {
  // Attempt to initialize audio, this will work if this is a callback for a user interaction.
  if (window.Cash5Vue) {
    window.Cash5Vue.initializeAudio();
  }

  document.body.classList.add('no-scroll');
  container.classList.remove('cash-5-app-container--hide');
  container.classList.add('cash-5-app-container--show');

  initVue(config, appContainer);
}

/**
 * Hide the modal container.
 */
export function hide() {
  document.body.classList.remove('no-scroll');
  container.classList.add('cash-5-app-container--hide');
  container.classList.add('cash-5-app-container--pending');
  container.classList.remove('cash-5-app-container--show');

  setTimeout(function() {
    container.classList.remove('cash-5-app-container--pending');
  }, 500);
}

let isStarted = false;
/**
 * Inject the modal container into the DOM.
 *
 * @param {object} userConfig
 * @returns void
 */
export function start(userConfig) {

  if (isStarted) {
    return;
  }
  isStarted = true;

  /** Configuration */
  userConfig = userConfig || {};
  const defaultConfig = {
    assetBase: '/',
  };
  config = Object.assign(defaultConfig, userConfig);

  if (document.readyState === 'interactive') {
    appContainer = createContainer(container, config);
    if (queryStringValue('cash-5-start')) {
      show();
    }
  } else {
    window.addEventListener('DOMContentLoaded', () => {
      appContainer = createContainer(container, config);
      if (queryStringValue('cash-5-start')) {
        show();
      }
    });
  }

  /** https://dev.to/maciejtrzcinski/100vh-problem-with-ios-safari-3ge9 */
  const viewportDimensions = () => {
    const doc = document.documentElement;
    // doc.style.setProperty('--cash-5-width', window.innerWidth);
    doc.style.setProperty('--cash-5-height', window.innerHeight);
    doc.style.setProperty('--cash-5-scale', Math.min(
      window.innerWidth / 375, // [320, 375] // see App.vue #Cash5App width
      window.innerHeight / 635 // [559, 635] // see App.vue #Cash5App height
    ));
  }
  window.addEventListener('resize', viewportDimensions)
  viewportDimensions()
}

/**
 * Initialize the Vue app inside the modal container.
 *
 * @param {object} config
 * @param {Element} container
 */
function initVue(config, container) {
  if (vueInitalized) {
    return;
  }
  vueInitalized = true;

  if (typeof window.Cash5Vue !== 'undefined') {
    window.Cash5Vue.init(config, container);
  } else {
    var s = document.createElement('script');
    s.onload = function() {
      window.Cash5Vue.init(config, container);
    };
    const src = config.assetBase + '/Cash5Vue.umd.min.js';
    s.setAttribute('src', src);
    s.async = true;
    document.body.appendChild(s);
  }
}

/** Auto-start the app in development mode */
if (process && process.env && process.env.NODE_ENV === 'development') {
  window.Cash5App = {
    start,
    show,
    hide,
  };

  start({
    assetBase: '/assets/',
  });
}
